/// <amd-module name="Core/Medius.Core.Web/Scripts/Orderbased/grid/objectDataSource"/>
import BaseGridDataSource = require("Core/Medius.Core.Web/Scripts/Medius/components/grid/dataSource/default");
import {create} from "Core/Medius.Core.Web/Scripts/Medius/components/grid/parser/default";
import * as koUtils from "Core/Medius.Core.Web/Scripts/Medius/knockout/utils";
import * as propertyResolver from "Core/Medius.Core.Web/Scripts/Medius/components/resolver/property";
import * as componentResolver from "Core/Medius.Core.Web/Scripts/Medius/components/resolver/component";
import {configuration as presenterResolver} from "Core/Medius.Core.Web/Scripts/Medius/components/presenters/bindings";
import * as _ from "underscore";
import { isNullOrUndefined } from "Core/Medius.Core.Web/Scripts/lib/underscoreHelpers";

const parser = create();

function presentValue(row: any, path: any, localize: any) {
    let presenter: any, localized: any;

    const value = koUtils.unpack(parser.resolveColumnValue(row, { ValueSource: path }));

    if (isNullOrUndefined(value)) {
        return value;
    }

    if (typeof value === "string") {
        return value.toLowerCase();
    }

    if (value.LocalizedValue) {
        localized = value.LocalizedValue();
    } else {
        const type = propertyResolver.resolvePropertyType(value, row);
        const presenterConfig: any = presenterResolver[componentResolver.resolve(type)];
        const factory = require(presenterConfig.factory);
        presenter = factory.create({
            value: value,
            notLocalized: !localize
        });
        localized = presenter.LocalizedValue();
        presenter.dispose();
    }

    if (typeof localized === "string") {
        return localized.toLowerCase();
    }

    if (localized) {
        localized = localized.toString().toLowerCase();
    }

    return localized;
}

function sortValue(row: any, path: any) {
    const value = koUtils.unpack(parser.resolveColumnValue(row, { ValueSource: path }));

    if (isNullOrUndefined(value)) {
        return value;
    }

    if (value.OriginalValue) {
        return koUtils.unpack(value.OriginalValue);
    }

    if (value.LocalizedValue) {
        return koUtils.unpack(value.LocalizedValue);
    }

    if (value.DisplayValue) {
        return koUtils.unpack(value.DisplayValue);
    }

    if (value.CustomField) {
        return koUtils.unpack(value.CustomField);
    }

    return presentValue(row, path, false);
}

export class ObjectBaseDataSource extends BaseGridDataSource {
    constructor() {
        super();
    }

    search(dataQuery: any, rows: any) {
        const regexs = this.buildRegexs(dataQuery);
        
        return this.searchByRegexs(rows, regexs);
    }
    
    searchByRegexs(rows: any, regexs: any) {
        if (regexs.length === 0) {
            return rows;
        }

        return _(rows).filter((row) => {
            return _(regexs).every((regex) => {
                return this.testRow(row, regex);
            });
        });
    }
    
    buildRegexs(dataQuery: any) {
        return _(dataQuery.keywords).map((phrase, valueSource) => {
            return this.buildRegex(phrase, valueSource);
        });
    }

    buildRegex(phrase: any, valueSource: any) {
        if (typeof phrase === "string") {
            phrase = phrase.replace(".", "\\.").replace("*", "\\*").toLowerCase();
        }

        return {
            exp: new RegExp(`${phrase}`),
            valueSource: valueSource
        };
    }
    
    presentValue(row: any, path: any, localize: any): any {
        return presentValue(row, path, localize);
    }
    
    getSortValue(row: any, path: any) {
        return sortValue(row, path);
    }
    
    testRow(row: any, regex: any) {
        const value = this.presentValue(row, regex.valueSource, true);
        return regex.exp.test(value);
    }

}
